import { TApiProjectSection } from "@timenotes/shared/src/services/api-client/types"
import useCreateProjectSectionMutation from "@timenotes/shared/src/services/project-sections/queries/use-create-project-section-mutation"
import { Button} from "antd"
import TextField from "components/timenotes/fields/text-field"
import OutsideAlerter from "components/view-utils/outside-alerter"
import { Form, FormikProvider, useFormik } from "formik"
import { useState } from "react"
import { AddButton } from "./add-button"

interface AddSectionContainerProps {
  projectId: string
}

const AddSectionContainer = (props: AddSectionContainerProps) => {
  const {
    projectId
  } = props

  const [isEditing, setIsEditing] = useState(false)

  const createProjectSectionMutation = useCreateProjectSectionMutation({
    projectId
  }, {
    onMutate: () => {
      formik.setSubmitting(true)
    },
    onSuccess: () => {
      setIsEditing(false)
      formik.resetForm()
    },
    onError: (errors) => {
      formik.setErrors(errors)
    },
    onSettled: () => {
      formik.setSubmitting(false)
    }
  })

  const formik = useFormik<Partial<TApiProjectSection>>({
    initialValues: {
      name: '',
      projectId: projectId,
    },
    onSubmit: (values, formikHelper) => {
      createProjectSectionMutation.mutate({
        name: values.name
      })
    }
  })

  return (
    <AddSection  
      formik={formik}
      isEditing={isEditing}
      setIsEditing={setIsEditing}
      {...props}
    />
  )
}

interface AddSectionProps {
  formik: ProjectSectionFormProps['formik']
  setIsEditing(isEditing: boolean): void
  isEditing: boolean
}

const AddSection = (props: AddSectionProps) => {
  const {
    formik,
    isEditing,
    setIsEditing
  } = props

  const handleCancel = () => {
    setIsEditing(false)
    formik.resetForm()
  }

  // If editing -> display form
  if (isEditing) {
    return (
      <OutsideAlerter
        onClick={handleCancel}
      >
        <div
          style={{
            width: '300px'
          }}
        >
          <ProjectSectionForm
            formik={formik}
            onCancel={handleCancel}
          />
        </div>
      </OutsideAlerter>
    )
  }

  // If not editing -> display button
  return (
    <AddButton
      onClick={() => setIsEditing(true)}
    >
      Add Section
    </AddButton>
  )
}

interface ProjectSectionFormProps {
  formik: ReturnType<typeof useFormik<Partial<TApiProjectSection>>>
  onCancel(): void
}

const ProjectSectionForm = (props: ProjectSectionFormProps) => {
  const {
    formik,
    onCancel
  } = props

  return (
    <FormikProvider value={formik}>
      <Form>
        <TextField
          name="name"
          autoFocus={true}
          placeholder="Section name"
        />

        <div
          style={{
            marginTop: '25px',
            display: 'flex',
            gap: '15px',
          }}
        >
          <Button
            type="primary"
            loading={formik.isSubmitting}
            onClick={formik.submitForm}
          >
            Create
          </Button>

          <Button
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </FormikProvider>
  )
}

export default AddSectionContainer
